<template>
  <div :style="wrapStyle">
    <c-button ref="button" :style="buttonStyle" v-bind="$props"></c-button>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
export default {
  name: 'CShanxianJumpAward',
  components: {
    [button.name]: button,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'shanxian-jump-award-',
      sessionKeyPrefix: 'ceiba_IsRead-',
      receiveStatus: 'reward',
    };
  },
  computed: {
    wrapStyle() {
      return {
        ...this.styles.base,
        backgroundImage: `url(${this.backgroundImageMap[this.receiveStatus]})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0 0',
      };
    },
    buttonStyle() {
      return {
        position: 'unset',
      };
    },
    enable() {
      const packageStatus = this.quaInfo[this.configurationData.flowId];
      console.log({ packageStatus });
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    backgroundImageMap() {
      return {
        reward: this.configurationData.jumpBackgroundImg || '',
        rewarded: this.configurationData.finishedBgImg || '',
      };
    },
  },
  async mounted() {
    console.log('jump award configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    async initialize() {
      this.$refs.button.setClickHandler(this.jumpAward, {
        forceApp: true,
        forceLogin: true,
        forceRole: this.configurationData.forceRole,
      });
      // 登录后
      this.$onLogined(async () => {
        this.startListen();
      });
      this.$onQuaRefreshed(async () => {
        this.receiveStatus = this.enable ? 'reward' : 'rewarded';
        console.log(
          'this.quaInfo---;',
          this.quaInfo[this.configurationData.flowId],
        );
      });
    },
    jumpAward() {
      console.log('jumpAward');
      // 跳转
      if (this.receiveStatus === 'rewarded') return;
      this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '03', '26');
      if (this.configurationData.clickReport !== '') {
        const [eventType, extendId] = this.configurationData.clickReport.split(',');
        this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, eventType, extendId);
      }
      this.setTask();
      let url = this.configurationData.link;
      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      url = common.tool.passThroughUrlParam(url, ['via', 'trace_id', 'via_source']);
      this.$ast.openView({ url });
    },
    async startListen() {
      setInterval(async () => {
        if (!window.document.hidden) {
          // eslint-disable-next-line max-len
          // console.log(`session:${sessionStorage.getItem(`${this.sessionKeyPrefix + this.uid}`)}, islogin: ${this.isLogin}`);
          if (
            sessionStorage.getItem(`${this.sessionKeyPrefix + this.uid}`)
              === '1'
            && this.isLogin
            && this.receiveStatus === 'reward'
          ) {
            console.log('回到页面');
            sessionStorage.setItem(`${this.sessionKeyPrefix + this.uid}`, 0);
            const res = await this.flowRequest({
              flowId: this.configurationData.flowId,
              params: {
                role: this.roleInfo,
                // data: JSON.stringify({}),
              },
            });
            console.log('task response', res);
            if (res.ret === 0 && res.data.ret === 0) {
              this.refreshQua();
              this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, '06', '02');
              if (this.configurationData.finishedReport !== '') {
                const [eventType, extendId] = this.configurationData.finishedReport.split(',');
                this.$pluginSparkReport.report(this.pageInfo.canvasConfig.reportPv, eventType, extendId);
              }
            }
          }
        } else {
          // console.log('页面被隐藏');
        }
      }, 1000);
    },
    setTask() {
      setTimeout(() => {
        sessionStorage.setItem(`${this.sessionKeyPrefix + this.uid}`, 1);
      }, 1000);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
